import {ENGAGEMENTS, PROJECT_NAME} from './constants';
import {projectKind} from '../../../../util/uiconstants';

export default (values, projectOwner, engagements, clients) => {
	const engagementsData = engagements
		.filter(({id}) => values[ENGAGEMENTS].includes(id))
		.map(({id, description, roleType}) => ({engagementId: id, description, groupRoleId: roleType}));

	return {
		body: {
			name: values[PROJECT_NAME],
			engagements: engagementsData,
			owners: [projectOwner],
			engagementCount: values[ENGAGEMENTS].length,
			Kind: projectKind.GRA,
			clients
		}
	};
};
